/**
 * ControllerIndicator displays the currently active controller badge in the header.
 *
 * Why: When using gamepad emulation, users need visual feedback about which
 * controller is currently selected. This indicator shows a colored badge
 * with a controller icon.
 *
 * When to use: Rendered by Header when controller emulation is active.
 * Receives indicator state as props from HeaderContainer.
 */
import { cn } from '@merels/ui'
import gameControllerSvg from '../../../assets/game-controller-svgrepo-com.svg?raw'

export interface ControllerIndicatorProps {
  /** Title/tooltip for the indicator */
  title: string
  /** Background color variant for the badge */
  badgeBgColor: 'red' | 'blue' | 'lime' | 'default'
  /** Opacity level for the icon */
  iconOpacity: 'low' | 'full'
}

export function ControllerIndicator({
  title,
  badgeBgColor,
  iconOpacity,
}: ControllerIndicatorProps) {
  const badgeBgClass =
    badgeBgColor === 'red'
      ? 'bg-red-500'
      : badgeBgColor === 'blue'
        ? 'bg-blue-500'
        : badgeBgColor === 'lime'
          ? 'bg-lime-500'
          : 'bg-gray-400 dark:bg-gray-600'

  const iconOpacityClass = iconOpacity === 'low' ? 'opacity-35' : 'opacity-100'

  return (
    <div
      className="flex h-[var(--menu-btn-size)] w-[var(--menu-btn-size)] items-center justify-center"
      title={title}
    >
      <div
        className={cn("rounded-full flex items-center justify-center", badgeBgClass)}
        style={{
          width: 'calc(var(--menu-btn-size) * 0.90)',
          height: 'calc(var(--menu-btn-size) * 0.90)',
        }}
      >
        <span
          className={cn(
            "[&>svg]:w-[16px] [&>svg]:h-[16px] [&>svg]:block text-white",
            iconOpacityClass
          )}
          dangerouslySetInnerHTML={{ __html: gameControllerSvg }}
        />
      </div>
    </div>
  )
}
